import React, { useContext, useEffect, useRef, useState } from "react";

import { Text, View, Image, Platform, TouchableOpacity, FlatList, Modal, Animated, Alert, ImageResizeMode } from "react-native";
import AppTheme from "../../utils/Theme";
import ComponentProps from "../../../specific/utils/Interfaces/ComponentProps";
import ActivityIndicator from "../../designSystem/ActivityIndicator/ActivityIndicator";
import { pop, push } from "../../../specific/utils/Navigation/Navigation";
import { useNavigate, useParams } from "../../../specific/utils/Navigation/Navigation";
import { getLocalActivities, getLocalActivitiesByCategories, getLocalCategories } from "../../../specific/utils/LocalStorage";
import i18n, { getLanguage } from "../../utils/Localization/Localization";
import { default as IcBack } from "../../assets/svg/lili/ic_back_arrow.svg";
import Images from "../../../specific/utils/Images";
import CategoryHomeStyle from "../../styles/categories/CategoryHomeStyle";
import MainStyle from "../../styles/game/MainStyle";
import User from "../../data/user/User";
import { EventFiltersByLevelChanged, ScreenActivityMediaList, ScreenActivityPager, ScreenActivitySheet } from "../../utils/Constants";
import Activity, { getActivityAvalability } from "../../models/Activity";
import ActivityMediaList from "../Activities/ActivityMediaList/ActivityMediaList";
import ActivityIcon from "../Activities/ActivityViews/ActivityIcon";
import { replaceCustomVariablesInString } from "../../utils/StringUtils";
import { build } from "../../../../package.json";
import { analyticsEventCategoryViewed, propertiesEventCategory, trackEvent } from "../../services/Tracking/Analytics";
import { default as IcFilter } from "../../assets/svg/lili/ic_filter.svg";

import * as Navigation from "../../../specific/utils/Navigation/Navigation";

import { EventRegister } from "../../utils/EventListeners";
import ActivitySheet from "../Activities/ActivitySheet";
import InViewModal from "../../../specific/components/InViewModal/InViewModal";
import { LocalDBContext } from "../../data/LocalDB";
import DeepLink from "../../services/DeepLink/DeepLink";
import NavBarButton from "../NavBar/NavBarButton";
import { headerImages } from "../Section/SectionCategories";
import Tips from "../../models/Tips";
import TipsButton from "../TipsButton/TipsButton";
import NavBar from "../../../specific/components/NavBar/NavBar";
import UserLevelSelection from "../Filters/UserLevelSelection";
import { AsyncStorageKey, getItemFromAsyncStorage } from "../../utils/AsyncStorage/AsyncStorage";

interface CategoryHomeProps extends ComponentProps {
    categoryKey?: string,
    sectionKey?: string,
    activities?: Activity[],
    header?: string,
    title?: string,
    section?: string,
    origin?: string,
    isModal?: boolean,
    webCloseRequest?: () => void,
    starting_point?: string
}


const CategoryHome = (props: CategoryHomeProps) => {

    const appTheme: AppTheme = new AppTheme();
    const images: Images = new Images();
    const categoryHomeStyle: CategoryHomeStyle = new CategoryHomeStyle();
    const user: User = User.getInstance();
    const localDBData = useContext(LocalDBContext);


    const activitiesByLine = ((Platform.OS === "web") && (appTheme.getFlexDirectionForSplitScreen() === "row")) ? 5 : 3;

    const [viewDidAppear, setViewDidAppear] = useState<boolean>(false);
    const [adminModeValue, setAdminModeValue] = useState<boolean>(false);
    const [category, setCategory] = useState<any>(undefined);
    const [localActivities, setLocalActivities] = useState(undefined);
    const [localActivitiesByCategory, setLocalActivitiesByCategory] = useState(undefined);
    const [localSections, setLocalSections] = useState(undefined);
    const [activitiesForCategory, setActivitiesForCategory] = useState<any[] | undefined>(undefined);
    const [selectedActivity, setSelectedActivity] = useState<Activity | undefined>(undefined);

    const [filterByLevel, setFilterByLevel] = useState<{ filter: string, last_update: number } | undefined>(undefined);
    const [showFilters, setShowFilters] = useState<boolean>(false);

    const contentViewOpactiy: Animated.Value = useRef(new Animated.Value(1)).current;

    const inViewModal = useRef<InViewModal>(null);

    let propsData = props;
    if ((Platform.OS === "web") && (props.isModal === undefined)) {
        propsData = useParams();
    }
    let navigate: any = null;
    if (Platform.OS === "web") {
        navigate = useNavigate();
    }

    const { categoryKey, sectionKey, componentId, activities, header, title, section, origin, isModal = false, webCloseRequest, starting_point = "superpower" } = propsData;
    // 0
    useEffect(() => {
        EventRegister.addEventListener(EventFiltersByLevelChanged, () => {
            getActiveFiltersByLevel();
        });
        return () => {
            EventRegister.removeEventListener(EventFiltersByLevelChanged);
        };
    }, []);

    const onViewDidAppear = async () => {
        if ((categoryKey !== undefined) && (categoryKey.length > 0)) {
            // On va récupérer les données de la catégorie
            if (user.admin === true) {
                try {
                    const adminDataString = await getItemFromAsyncStorage({ itemKey: AsyncStorageKey.adminData });
                    if (adminDataString === null) {
                        setAdminModeValue(false);
                    } else {
                        const adminData = adminDataString.data;
                        if (adminData.editionMode !== undefined) {
                            setAdminModeValue(adminData.editionMode);
                        } else {
                            setAdminModeValue(false);
                        }
                    }
                } catch (error) {
                    setAdminModeValue(false);
                }
            }
            getCategoryDetails();
            getSectionDetails();
        } else {
            // Erreur de lien on revient en arrière
            goBack();
        }
    }

    const getSectionDetails = async () => {
        const sections = localDBData.sections.data;
        setLocalSections(sections);
    }

    const getCategoryDetails = async () => {
        const localCategoriesFromStorage = await getLocalCategories();
        if (localCategoriesFromStorage.data[categoryKey] !== undefined) {
            setCategory(localCategoriesFromStorage.data[categoryKey]);
        } else {
            goBack();
        }
    }

    useEffect(() => {
        if (category !== undefined) {
            // On va récupérer les activités pour la catégorie
            trackEvent(analyticsEventCategoryViewed, {
                [propertiesEventCategory]: category.analytics_key,
                starting_point
            })
            if (activities !== undefined) {
                setLocalActivitiesByCategory({ [categoryKey]: activities });
            } else {
                getLocalActivitiesByCategoryFromStorage();
            }
        }
    }, [category]);

    useEffect(() => {
        if (localActivitiesByCategory !== undefined) {
            if ((localActivitiesByCategory[categoryKey] !== undefined) && (localActivitiesByCategory[categoryKey].length > 0)) {
                getActivities();
            } else {
                goBack();
            }
        }
    }, [localActivitiesByCategory]);

    const getActivities = async () => {
        const localActivitiesFromStorage = await getLocalActivities();
        setLocalActivities(localActivitiesFromStorage.data);
    }

    useEffect(() => {
        if (localActivities !== undefined) {
            getActiveFiltersByLevel();
        }
    }, [localActivities]);

    // 8
    const getActiveFiltersByLevel = async () => {
        const user: User = User.getInstance();
        setFilterByLevel({ filter: user.children_level ?? "cycle2", last_update: new Date().getTime() });
    }

    // 9
    useEffect(() => {
        if (filterByLevel !== undefined) {
            getActivitiesListForCategory();
        }
    }, [filterByLevel]);

    useEffect(() => {
        if (activitiesForCategory !== undefined) {
            setViewDidAppear(true);
        }
    }, [activitiesForCategory]);

    useEffect(() => {
        if (viewDidAppear === true) {
            // On va regarder si on doit montrer une activité
            const deeplink: DeepLink = DeepLink.getInstance();
            if (deeplink.activity_key.length > 0) {
                // On doit montrer une activité. Donc on a forcément la clé de la catégorie
                let activityIndex: number = 0;
                let activityToShow: Activity | undefined = undefined;
                for (const anActivityIndex in activitiesForCategory) {
                    if (Object.prototype.hasOwnProperty.call(activitiesForCategory, anActivityIndex)) {
                        const anActivity: Activity = activitiesForCategory[anActivityIndex];
                        if (anActivity.key === deeplink.activity_key) {
                            activityIndex = parseInt(anActivityIndex);
                            activityToShow = anActivity;
                            break;
                        }
                    }
                }
                showActivityMedias(activityToShow, activityIndex);
                deeplink.activity_key = "";
            }
        }
    }, [viewDidAppear]);

    const getCategoryColors = () => {
        let categoryColors = {
            btn: appTheme.daySkyColor,
            header_bg: appTheme.daySkyColor,
            nav: appTheme.daySkyColor,
            txt: appTheme.white
        };
        if (category !== undefined) {
            const { clr } = category;
            if (clr !== undefined) {
                categoryColors = clr;
            } else {
                let catSectionKey: string = category.sectionId ?? sectionKey;
                if (catSectionKey === "still") {
                    categoryColors = {
                        btn: appTheme.still,
                        header_bg: appTheme.still,
                        nav: "#A2F2F8",
                        txt: appTheme.darkBlue
                    }
                } else if (catSectionKey === "talk") {
                    categoryColors = {
                        btn: appTheme.talk,
                        header_bg: "#FFAA8C",
                        nav: appTheme.talk,
                        txt: appTheme.white
                    }
                } else if (catSectionKey === "grow") {
                    categoryColors = {
                        btn: appTheme.grow,
                        header_bg: "#51D2A8",
                        nav: appTheme.grow,
                        txt: appTheme.white
                    }
                } else if (catSectionKey === "super_program") {
                    categoryColors = {
                        btn: appTheme.darkBlue,
                        header_bg: appTheme.darkBlue,
                        nav: appTheme.darkBlue,
                        txt: appTheme.white
                    }
                } else if (catSectionKey === "inspire") {
                    categoryColors = {
                        btn: "#7A80D4",
                        header_bg: "#A2A8FF",
                        nav: "#7A80D4",
                        txt: "#25364f"
                    }
                }
            }
        }
        return categoryColors;
    }

    const getActivitiesListForCategory = () => {
        // On doit ajouter l'affichage en fonction du filtre et potentiellement du super pouvoir
        let activitiesToDisplay = [];
        if (localActivities !== undefined) {
            let freeActivitiesToDisplay = [];
            let premiumActivitiesToDisplay = [];
            for (const anActivityKeyIndex in localActivitiesByCategory[categoryKey]) {
                if (Object.prototype.hasOwnProperty.call(localActivitiesByCategory[categoryKey], anActivityKeyIndex)) {
                    const anActivityKey: Activity = localActivitiesByCategory[categoryKey][anActivityKeyIndex];
                    if (localActivities[anActivityKey] !== undefined) {
                        const anActivity = localActivities[anActivityKey];
                        const sectionMinBuildNumber: number = anActivity.min_build_number ?? 0;
                        const sectionMaxBuildNumber: number = anActivity.max_build_number ?? 0;
                        let displayActivity: boolean = false;
                        if ((user.admin === true) && (adminModeValue === true)) {
                            displayActivity = true;
                        } else {
                            if (anActivity.status !== "draft") {
                                if (sectionMinBuildNumber < parseInt(build)) {
                                    if ((sectionMaxBuildNumber > parseInt(build)) || (sectionMaxBuildNumber === 0)) {
                                        displayActivity = true;
                                    }
                                }
                            }
                        }
                        if (displayActivity === true) {
                            // On regarde si l'activité correspond aux filtres
                            let addActivity: boolean = true;
                            if ((filterByLevel !== undefined) && (filterByLevel.filter !== undefined) && (anActivity.cycles !== undefined)) {
                                if (anActivity.cycles.includes(filterByLevel.filter) === false) {
                                    addActivity = false;
                                }
                            }
                            const superPowerTags: string[] = ["collective", "criticalThinking", "emotionsTaming", "errorTaming", "focus", "selfEsteem", "speak"];
                            if ((origin !== undefined) && (superPowerTags.indexOf(origin) !== -1)) {
                                if (anActivity.tags !== undefined) {
                                    if (anActivity.tags.indexOf(origin) === -1) {
                                        addActivity = false;
                                    }
                                }
                            }
                            if (addActivity === true) {
                                let activityIncluded = false;
                                if ((anActivity.access.is_essential === true) || (anActivity.access.is_premium === true)) {
                                    for (const aPremiumActivityIndex in premiumActivitiesToDisplay) {
                                        if (Object.prototype.hasOwnProperty.call(premiumActivitiesToDisplay, aPremiumActivityIndex)) {
                                            const aPremiumActivity = premiumActivitiesToDisplay[aPremiumActivityIndex];
                                            if (aPremiumActivity.order > anActivity.order) {
                                                premiumActivitiesToDisplay.splice(aPremiumActivityIndex, 0, anActivity);
                                                activityIncluded = true;
                                                break;
                                            }
                                        }
                                    }
                                    if (activityIncluded === false) {
                                        premiumActivitiesToDisplay.push(anActivity);
                                    }
                                } else {
                                    for (const aFreeActivityIndex in freeActivitiesToDisplay) {
                                        if (Object.prototype.hasOwnProperty.call(freeActivitiesToDisplay, aFreeActivityIndex)) {
                                            const aFreeActivity = freeActivitiesToDisplay[aFreeActivityIndex];
                                            if (aFreeActivity.order > anActivity.order) {
                                                freeActivitiesToDisplay.splice(aFreeActivityIndex, 0, anActivity);
                                                activityIncluded = true;
                                                break;
                                            }
                                        }
                                    }
                                    if (activityIncluded === false) {
                                        freeActivitiesToDisplay.push(anActivity);
                                    }
                                }
                            }
                        }
                    }
                }
            }
            activitiesToDisplay = freeActivitiesToDisplay.concat(premiumActivitiesToDisplay);
        }
        console.log({ activitiesForCategory: activitiesToDisplay?.length });
        setActivitiesForCategory(activitiesToDisplay);
    }

    const getLocalActivitiesByCategoryFromStorage = async () => {
        const localActivitiesByCategoryFromStorage = await getLocalActivitiesByCategories();
        setLocalActivitiesByCategory(localActivitiesByCategoryFromStorage.data);
    }

    const goBack = () => {
        if (isModal === true) {
            if (webCloseRequest !== undefined) {
                webCloseRequest();
            } else if (Platform.OS !== "web") {
                Navigation.dismissModal({ componentId, navigate })
            }
        } else {
            pop({ componentId, navigate });
        }
    }

    const renderNavBar = () => {
        const tips: Tips = Tips.getInstance();
        const { title } = category;
        const clr = getCategoryColors();
        let titleToDisplay = replaceCustomVariablesInString(title[getLanguage()]);
        if (Platform.OS === "web") {
            let showLevel: boolean = true;
            if (section === "superPowers") {
                titleToDisplay = i18n.t("tags." + origin);
            } else if ((localSections !== undefined) && (localSections[section] !== undefined)) {
                titleToDisplay = localSections[section].title[getLanguage()];
            }
            if ((categoryKey === "cps") || (categoryKey === "wellBeing") || (categoryKey === "phi_questions")) {
                showLevel = false;
            }
            return <NavBar showLevel={showLevel} sectionkey={section} categoryColors={clr} tips={tips.sections} title={titleToDisplay} />;
        }

        let navBarColor = clr.nav;
        let navBarTextColor = clr.txt;
        const titlesHorizontalAlign: string = "flex-start";
        const titleSuperHeroFontSize: number = appTheme.pixelPerfectForFont(9);
        let tipsButton: React.JSX.Element = <View />;
        if (tips.sections !== undefined) {
            if (tips.sections[sectionKey] !== undefined) {
                tipsButton = <TipsButton color={navBarColor} style={{ marginEnd: appTheme.pixelPerfect(10) }} tips={tips.sections[sectionKey]} />;
            }
        }
        let filterButton: React.JSX.Element = <NavBarButton icon={IcFilter} action={toggleFilters} />;
        let navBarSubtitleView: React.JSX.Element = <Text style={{ color: navBarTextColor, fontFamily: appTheme.primarySemiBoldFont, fontSize: appTheme.pixelPerfectForFont(7) }}>{i18n.t("levels." + user.children_level).toLocaleLowerCase()}</Text>;
        if ((categoryKey === "cps") || (categoryKey === "wellBeing") || (categoryKey === "phi_questions")) {
            navBarSubtitleView = <View />;
            filterButton = <View />;
        }
        return <View style={{ position: "absolute", flexDirection: "row", width: appTheme.getFullAppWidth(), paddingTop: appTheme.topInsets, alignItems: "center", paddingHorizontal: appTheme.pixelPerfect(10), height: appTheme.pixelPerfect(60) + appTheme.topInsets, backgroundColor: navBarColor }}>
            <NavBarButton style={{ marginEnd: appTheme.pixelPerfect(10) }} icon={IcBack} action={goBack} />
            <View style={{ flex: 1, alignItems: titlesHorizontalAlign }}>
                <Text style={{ color: navBarTextColor, fontFamily: appTheme.superHerosFontBold, fontSize: titleSuperHeroFontSize }}>{titleToDisplay.replace("\\n", "\n")}</Text>
                {navBarSubtitleView}
            </View>
            {tipsButton}
            {filterButton}
        </View>
    }

    useEffect(() => {
        let contentViewOpactiyFinalValue = selectedActivity === undefined ? 1 : 0;
        Animated.timing(contentViewOpactiy, {
            toValue: contentViewOpactiyFinalValue,
            duration: 500,
            useNativeDriver: false
        }).start();
    }, [selectedActivity]);

    const showActivitySheet = (data: { index: number, activityKey: string }) => {
        const { activityKey, index } = data;
        const name = Platform.OS === 'web' ? ScreenActivitySheet : ScreenActivityPager;

        const passProps = Platform.OS === 'web' ? {
            activityKey,
            categoryKey,
            sectionKey: section,
            context: user.profile,
            starting_point
        } : {
            activityKey,
            categoryKey,
            sectionKey: section,
            context: user.profile,
            activities: activitiesForCategory,
            index,
            starting_point
        };
        push({
            componentId,
            navigate,
            passProps,
            name
        })
    }

    const showActivityMedias = (item, index) => {
        if (Platform.OS === "web") {
            window.scrollTo(0, 0);
            setSelectedActivity(item);
        } else {
            // On va faire une différence entre WellBeing & Philo qui doivent montrer des listes de médias et les autres qui doivent montrer des activités.
            if ((categoryKey === "wellBeing") || (categoryKey === "phi_questions") || (categoryKey === "quotes") || (categoryKey === "cps")) {
                push({
                    componentId,
                    navigate,
                    name: ScreenActivityMediaList,
                    passProps: {
                        activity: item,
                        category
                    }
                });
            } else {
                showActivitySheet({ index: parseInt(index), activityKey: item.key });
            }
        }
    }

    const activitiesGridCell = ({ item, index }) => {
        const refWidth = Platform.OS === "web" ? appTheme.getBlockWidth() : appTheme.getFullAppWidth();
        const marginLeft = Platform.OS === "web" ? appTheme.pixelPerfect(10) : appTheme.pixelPerfect(10);
        const marginRight = Platform.OS === "web" ? appTheme.pixelPerfect(10) : appTheme.pixelPerfect(10);
        const cellSize = (refWidth - (activitiesByLine * (marginLeft + marginRight))) / activitiesByLine;
        const marginTop = Platform.OS === "web" ? 0 : appTheme.pixelPerfect(10);
        let localPath: string = item.app_image;
        let remotePath: string = item.img_url;
        let title: string = item.title[getLanguage()];
        let imageSize = appTheme.pixelPerfect(80);
        if (imageSize > (cellSize - appTheme.pixelPerfect(10))) {
            imageSize = cellSize - appTheme.pixelPerfect(10);
        }
        const textFontSize = Platform.OS === "web" ? appTheme.pixelPerfectForFont(10) : appTheme.pixelPerfectForFont(6);
        // On va regarder si on a une iimage spécifique pour le type d'utilisateur
        if (item[user.profile] !== undefined) {
            const userProfileItem = item[user.profile];
            if (userProfileItem.app_image !== undefined) {
                localPath = userProfileItem.app_image;
            }
            if (userProfileItem.img_url !== undefined) {
                remotePath = userProfileItem.img_url;
            }
            if ((userProfileItem.title !== undefined) && (userProfileItem.title[getLanguage()] !== undefined)) {
                title = userProfileItem.title[getLanguage()];
            }
        }
        return <TouchableOpacity key={item.key} onPress={() => showActivityMedias(item, index)} style={{ marginTop, marginLeft, marginRight, alignItems: "center", backgroundColor: appTheme.white, width: cellSize }}>
            <ActivityIcon isPremium={item.access.is_premium} status={item.status} isActivityAvailable={getActivityAvalability(item)} remotePath={remotePath} localPath={localPath} isSquare={true} withShadow={true} size={cellSize} />
            <View style={{ marginTop: appTheme.pixelPerfect(5), width: "80%", justifyContent: "flex-start", flex: 1 }}>
                <Text numberOfLines={3} style={{ fontFamily: appTheme.primaryBoldFont, color: appTheme.darkBlue, textAlign: "center", fontSize: textFontSize }}>{`${title}`}</Text>
            </View>
        </TouchableOpacity>
    }

    // Affichage des filtes
    const toggleFilters = () => {
        setShowFilters(!showFilters);
    }

    const getActivitiesGrid = () => {
        const lineWidth = appTheme.getBlockWidth();
        let activitesGrid = [];
        let activitiesLine = [];
        const { title } = category;
        const clr = getCategoryColors();
        const navBarColor = clr.nav;
        const navBarTextColor = clr.txt;
        const titleToDisplay = replaceCustomVariablesInString(title[getLanguage()]);
        activitesGrid.push(<View style={{ width: lineWidth, height: appTheme.pixelPerfect(50), backgroundColor: navBarColor, justifyContent: "center", alignItems: "center", flexDirection: "row", paddingHorizontal: appTheme.pixelPerfect(10), marginBottom: appTheme.pixelPerfect(30) }}>
            <View style={{ flex: 1, justifyContent: "center", alignItems: "center" }}>
                <Text numberOfLines={2} style={{ paddingHorizontal: appTheme.pixelPerfect(10), fontFamily: appTheme.primaryBoldFont, fontSize: appTheme.pixelPerfectForFont(9), textAlign: "center", textTransform: "uppercase", color: navBarTextColor }}>{titleToDisplay.replace("\\n", "\n")}</Text>
            </View>
        </View>)
        const marginBottom = appTheme.pixelPerfect(40);
        console.log(JSON.stringify(activitiesForCategory));
        for (const anActivityIndex in activitiesForCategory) {
            if (Object.prototype.hasOwnProperty.call(activitiesForCategory, anActivityIndex)) {
                const anActivity = activitiesForCategory[anActivityIndex];
                let displayActivity: boolean = true;
                if ((anActivity[user.profile] !== undefined) && (anActivity[user.profile].display !== undefined)) {
                    displayActivity = anActivity[user.profile].display;
                }
                if ((anActivity.profiles !== undefined) && (anActivity.profiles.indexOf(user.profile) === -1)) {
                    displayActivity = false;
                }
                if (displayActivity === true) {
                    activitiesLine.push(activitiesGridCell({ item: anActivity, index: anActivityIndex }));
                    if (activitiesLine.length === activitiesByLine) {
                        activitesGrid.push(<View style={{ flexDirection: "row", alignItems: "flex-start", width: lineWidth, marginBottom }}>
                            {activitiesLine}
                        </View>);
                        activitiesLine = [];
                    }
                }
            }
        }
        if (activitiesLine.length > 0) {
            activitesGrid.push(<View style={{ flexDirection: "row", justifyContent: "flex-start", alignItems: "flex-start", width: lineWidth }}>
                {activitiesLine}
            </View>);
        }
        return activitesGrid;
    }

    const getListHeader = () => {
        const { img } = category;
        let headerBgColor = section === "superPowers" ? appTheme.darkBlue : undefined;
        if (headerBgColor === undefined) {
            const clr = getCategoryColors();
            headerBgColor = clr.header_bg;
        }
        let headerImageView = <View style={categoryHomeStyle.headerImage(headerBgColor)} />
        let source: any = undefined;
        if (header !== undefined) {
            source = images[header];
        } else if (headerImages[section] !== undefined) {
            source = images[headerImages[section]];
        } else {
            if ((img !== undefined) && (img.header !== undefined)) {
                if ((img.header.local !== undefined) && (images[img.header.local] !== undefined)) {
                    source = images[img.header.local];
                } else if ((Platform.OS === "web") && (img.header.web !== undefined)) {
                    source = { url: img.header.web };
                } else if ((Platform.OS !== "web") && (img.header.mobile !== undefined)) {
                    source = { url: img.header.mobile };
                }
            } else {
                if ((activitiesForCategory !== undefined) && (activitiesForCategory[0] !== undefined)) {
                    const firstActivty: Activity = activitiesForCategory[0];
                    if (firstActivty.app_image !== undefined) {
                        source = images[firstActivty.app_image];
                    } else if (firstActivty.img_url !== undefined) {
                        source = { url: firstActivty.img_url };
                    }
                }
            }
        }

        // On va regarder si on a une iimage spécifique pour le type d'utilisateur
        if (category[user.profile] !== undefined) {
            if ((category[user.profile].img !== undefined) && (category[user.profile].img.header !== undefined)) {
                if ((category[user.profile].img.header.local !== undefined) && (images[category[user.profile].img.header.local] !== undefined)) {
                    source = images[category[user.profile].img.header.local];
                } else if ((Platform.OS === "web") && (category[user.profile].img.header.web !== undefined)) {
                    source = { url: category[user.profile].img.header.web };
                } else if ((Platform.OS !== "web") && (category[user.profile].img.header.mobile !== undefined)) {
                    source = { url: category[user.profile].img.header.mobile };
                }
            }
        }

        const imageWidth: number = appTheme.getFullAppWidth();
        let imageHeight: number = imageWidth * 27 / 36;
        let resizeMode: ImageResizeMode = "cover";
        if (Platform.OS === "web") {
            imageHeight = imageWidth * 35 / 192;
            resizeMode = "contain";
        }

        if (source !== undefined) {
            headerImageView = <Image source={source} style={[categoryHomeStyle.headerImage(headerBgColor), { width: imageWidth, height: imageHeight, resizeMode }]} resizeMode={resizeMode} />;
        }

        const activitiesGrid = (Platform.OS === "web") ? <Animated.View style={[categoryHomeStyle.contentView, { alignItems: "center", opacity: contentViewOpactiy, overflow: "hidden" }]}>
            {getActivitiesGrid()}
        </Animated.View> : <View />;
        return <View style={{ width: appTheme.getFullAppWidth(), alignItems: "center" }}>
            {headerImageView}
            {activitiesGrid}
        </View>
    }

    const getActiviesList = () => {
        if (Platform.OS === "web") {
            return <View />
        } else {
            const tagsList: string[] = ["emotionsTaming", "errorTaming", "focus", "speak", "collective", "criticalThinking", "selfEsteem"];
            let listOfActivities: Activity[] = [];
            for (const anActivityIndex in activitiesForCategory) {
                if (Object.prototype.hasOwnProperty.call(activitiesForCategory, anActivityIndex)) {
                    const anActivity: Activity = activitiesForCategory[anActivityIndex];
                    let displayActivity: boolean = true;
                    if (categoryKey !== "cps") {
                        if ((anActivity[user.profile] !== undefined) && (anActivity[user.profile].display !== undefined)) {
                            displayActivity = anActivity[user.profile].display;
                        }
                        if ((anActivity.profiles !== undefined) && (anActivity.profiles.indexOf(user.profile) === -1)) {
                            displayActivity = false;
                        }
                        if ((origin !== undefined) && (tagsList.indexOf(origin) !== -1)) {
                            // Si on affiche la liste depuis un super pouvoir
                            // On va voir si l'activitié est tagué sur ce super pouvoir
                            if (anActivity.tags.indexOf(origin) === -1) {
                                displayActivity = false;
                            }
                        }
                    }
                    if (displayActivity === true) {
                        listOfActivities.push(anActivity);
                    }
                }
            }
            return <FlatList
                numColumns={3}
                ListHeaderComponent={getListHeader}
                data={listOfActivities}
                style={{ width: appTheme.getFullAppWidth(), backgroundColor: appTheme.white }}
                renderItem={activitiesGridCell}
                keyExtractor={(item, index) => {
                    return item.key
                }} />
        }
    }

    const getModalContent = () => {
        if (Platform.OS === "web") {
            if ((viewDidAppear === true) && (selectedActivity !== undefined)) {
                if ((categoryKey === "phi_questions") || (categoryKey === "wellBeing") || (categoryKey === "cps")) {
                    return <View style={[categoryHomeStyle.modalStyle]}>
                        <ActivityMediaList
                            category={category}
                            activity={selectedActivity}
                            webCloseRequest={() => setSelectedActivity(undefined)} />
                    </View>
                }
                return <View style={categoryHomeStyle.modalStyle}>
                    <ActivitySheet
                        inPager={true}
                        activityKey={selectedActivity.key}
                        sectionKey={selectedActivity.section_key}
                        categoryKey={categoryKey}
                        activity={selectedActivity}
                        webCloseRequest={() => setSelectedActivity(undefined)} />
                </View>
            }
        }
        return <View />;
    }

    const getContent = () => {
        if (viewDidAppear === false) {
            return <View onLayout={onViewDidAppear} style={{ flex: 1, justifyContent: "center", alignItems: "center" }}>
                <ActivityIndicator loading={true} color={appTheme.darkBlue} />
            </View>
        }
        let headerBgColor = section === "superPowers" ? appTheme.darkBlue : undefined;
        if (headerBgColor === undefined) {
            const clr = getCategoryColors();
            headerBgColor = clr.header_bg;
        }

        if (Platform.OS === "web") {
            return <View style={[categoryHomeStyle.mainView(headerBgColor)]}>
                <View style={categoryHomeStyle.mainBackground(headerBgColor)} />
                {getListHeader()}
                {renderNavBar()}
                {getModalContent()}
                <InViewModal ref={inViewModal} />
                <UserLevelSelection
                    visible={showFilters}
                    style={{ flex: 1, justifyContent: "flex-end" }}
                    backgroundColor={appTheme.schoolColor}
                    toggleFilters={toggleFilters} />
            </View>
        }

        return <View style={[categoryHomeStyle.mainView(headerBgColor)]}>
            <View style={categoryHomeStyle.mainBackground(headerBgColor)} />
            {getActiviesList()}
            {getModalContent()}
            {renderNavBar()}
            <InViewModal ref={inViewModal} />
            <UserLevelSelection visible={showFilters}
                style={{ flex: 1, justifyContent: "flex-end" }} backgroundColor={appTheme.schoolColor} toggleFilters={toggleFilters} />
        </View>
    }

    return getContent();
}

export default CategoryHome;